import { Injectable } from '@angular/core';
import {SupportFunction} from "../models/Support/SupportFunction";


@Injectable({
  providedIn: 'root'
})
export class SupportService {

  public supportFunctions: SupportFunction[] = [
    {
      url: "/auth/login",
      problem_message: "logging in",
      solution_message: "Our support team can help you get back into your account."
    }
  ]

  constructor() { }

  retrieveProblemMessage(url:string): string{
      const problem = this.supportFunctions.find((item) => item.url === url);
      if(problem){
        return problem.problem_message;
      }else{
        return 'the platform';
      }
  }

  retrieveSolutionMessage(url:string): string{
    const solution = this.supportFunctions.find((item) => item.url === url);
    if(solution){
      return solution.solution_message;
    }else{
      return "If you need help or want to report a problem with this feature, our support team are here to help.";
    }
  }

}
